import { latLngBounds, LatLngExpression } from 'leaflet';
import { getCombinedLevelAssetUserBounds } from '../utils/utils';
import L from 'leaflet';
import { MapStore } from 'stores/MapStore';
import { User } from 'types/userInfo';
import { Asset } from 'types/asset';
import { useContext } from 'react';
import { MapContainerRefContext } from '../utils/mapContainerRef.context';

export default function useMap(mapStore: MapStore) {
  const { mapContainerRef } = useContext(MapContainerRefContext)
  const {
    assets, outdoorAssets, users,
    outdoorUsers, levels, getBuildingLevels,
    selectedBuildingId,
    selectBuilding, selectFloor, getFirstNotEmptyFloor
  } = mapStore

  // for obtaining latlong at cursor.
  // useMapEvents({
  //   click: (ev) => console.log(ev.latlng),
  // });

  function fitMapToBoundsOfGeoJSON(geoJSONData: any, maxZoom: number = 21) {
    if (!mapContainerRef)
      return
    const geojsonLayer = L.geoJSON(geoJSONData);
    mapContainerRef.fitBounds(geojsonLayer.getBounds(), { padding: [50, 50], maxZoom: maxZoom });
  }

  function panToLatLong(eTargetLatLong: LatLngExpression) {
    if (!mapContainerRef)
      return
    mapContainerRef.panTo(eTargetLatLong);
  }

  function fitMapToFilterResults(map: L.Map, items: Asset[] | User[]) {
    const bounds = latLngBounds([]);
    const buildings: string[] = []

    if (items.length === 1) {
      if (selectedBuildingId === null && items[0].location.building_level?.possible_buildings[0].id) {
        selectBuilding(items[0].location.building_level.possible_buildings[0].id)
      }
      if (selectedBuildingId && selectedBuildingId === items[0].location.building_level?.possible_buildings[0].id) {
        selectFloor(getFirstNotEmptyFloor(selectedBuildingId))
      }
    }

    //show all buildings with searched items and also outdoor items
    for (const item of items) {
      if (item.location.is_outdoors)
        bounds.extend([item.location.coordinates.latitude, item.location.coordinates.longitude])
      else {
        item.location?.building_level?.possible_buildings?.forEach(building => {
          if (buildings.includes(building.id))
            return
          buildings.push(building.id)
          const buildingLevels = getBuildingLevels(building.id)
          const geoJSONLayer = L.geoJSON(buildingLevels as any);
          bounds.extend(geoJSONLayer.getBounds());
        })
      }
    }

    if (selectedBuildingId) {
      buildings.push(selectedBuildingId)
      const buildingLevels = getBuildingLevels(selectedBuildingId)
      const geoJSONLayer = L.geoJSON(buildingLevels as any);
      bounds.extend(geoJSONLayer.getBounds());
    }

    if (buildings.length === 0) {
      const geoJSONLayer = L.geoJSON(levels as any);
      bounds.extend(geoJSONLayer.getBounds());
    }

    map.fitBounds(bounds);
  }

  function panMapToShowAll(map: L.Map) {
    const combinedAssetBounds = [...assets, ...outdoorAssets];
    const combinedUserBounds = [...users, ...outdoorUsers];
    const bounds = getCombinedLevelAssetUserBounds(
      combinedAssetBounds,
      combinedUserBounds,
      levels,
    );
    map.fitBounds(bounds, { animate: true });
  }

  return {
    fitMapToBoundsOfGeoJSON,
    panToLatLong,
    fitMapToFilterResults,
    panMapToShowAll,
  };
}
